import useProfileUser from 'api/user/useProfileUser';
import { createContext, useContext, useState, useEffect } from 'react';
import { ProfileUserResponse } from 'types/user-profile';

type UserType = ProfileUserResponse["data"];

interface AppContextProps {
    isMobile: boolean;
    userDetail: UserType;
}

export const AppContext = createContext({} as AppContextProps);


// const AppContext = createContext<AppContextProps>({
//     isMobile: false,
//     userDetail

// });

export const AppProvider = ({ children }) => {
    const [isMobile, setIsMobile] = useState<boolean>(false);

    const data = useProfileUser();
    const userData = data?.data?.data?.data;

    const [userDetail, setUserDetail] = useState<UserType>(undefined);

    useEffect(() => {
        if (userData) {
            setUserDetail(userData);
        }
    }, [userData]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <AppContext.Provider value={{ isMobile, userDetail }}>
            {children}
        </AppContext.Provider>
    );
};

const useAppContext = () => {
    return useContext(AppContext);
};

export default useAppContext;
